import { render, staticRenderFns } from "./GlobalControl.vue?vue&type=template&id=6fc18b78&"
import script from "./GlobalControl.vue?vue&type=script&lang=js&"
export * from "./GlobalControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/m1292/Documents/develop/laravel/cure-naruhodoga/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fc18b78')) {
      api.createRecord('6fc18b78', component.options)
    } else {
      api.reload('6fc18b78', component.options)
    }
    module.hot.accept("./GlobalControl.vue?vue&type=template&id=6fc18b78&", function () {
      api.rerender('6fc18b78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/commons/GlobalControl.vue"
export default component.exports